import { fetchData } from './client';

export type ProfileResponse = {
  accountId: string;
  userName: string;
  transactionCount: number;
  registeredAt: string;
};

export const getProfile = async (): Promise<ProfileResponse> => {
  const response = await fetchData('users/me', {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error('プロフィールの取得に失敗しました');
  }

  const result: ProfileResponse = await response.json();
  return result;
};

export type UpdateProfileRequest = {
  accountId: string;
  displayName: string;
};

export type UpdateProfileResponse = {
  accountId: string;
  userName: string;
  updatedAt: string;
};

export const updateProfile = async (data: UpdateProfileRequest): Promise<UpdateProfileResponse> => {
  const response = await fetchData('users/me', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('プロフィールの更新に失敗しました');
  }

  const result: UpdateProfileResponse = await response.json();
  return result;
};
